const BLOCK_TAGS = new Set(["P", "DIV", "BR", "LI", "TR", "H1", "H2", "H3", "H4", "H5", "H6"]);

const decodeEntities = (value) => {
  if (typeof document === "undefined") return value;
  const element = document.createElement("textarea");
  element.innerHTML = value;
  return element.value;
};

export const toPlainText = (value = "") => {
  if (typeof value !== "string") return "";
  if (typeof DOMParser === "undefined") {
    return decodeEntities(value.replace(/<[^>]*>/g, " ")).replace(/\s+/g, " ").trim();
  }
  const parsed = new DOMParser().parseFromString(value, "text/html");
  parsed.body.querySelectorAll("script, style, iframe, object, embed, svg").forEach(node => node.remove());
  parsed.body.querySelectorAll("*").forEach(node => {
    if (BLOCK_TAGS.has(node.tagName)) node.after(document.createTextNode(" "));
  });
  return (parsed.body.textContent || "").replace(/\s+/g, " ").trim();
};

export const createExcerpt = (value, maxLength = 180) => {
  const plainText = toPlainText(value);
  const characters = typeof Intl.Segmenter === 'function'
    ? Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(plainText), part => part.segment)
    : Array.from(plainText);
  if (characters.length <= maxLength) return plainText;
  if (maxLength <= 0) return '';
  if (maxLength === 1) return '…';
  const shortened = characters.slice(0, maxLength - 1).join('');
  const lastSpace = shortened.lastIndexOf(' ');
  // Keep a complete boundary word; only hard-cut a single overlong token.
  const end = characters[maxLength - 1] === ' ' || lastSpace < 0 ? shortened.length : lastSpace;
  return `${shortened.slice(0, end).trim()}…`;
};
